import i18next from 'i18next';
import React from 'react';
import en from './i18n/en';
import ptBr from './i18n/pt-br';

i18next.addResourceBundle('pt-br', 'receita/cadastro/venda', ptBr);
i18next.addResourceBundle('en', 'receita/cadastro/venda', en);

const VendaConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: '/vendas-servicos/venda',
      component: React.lazy(() => import('./Venda')),
    },
  ],
};

export default VendaConfig;
